import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onMounted, onUnmounted } from 'vue'
import axios from 'axios'
import PaintingsColumn from './PaintingsColumn.vue'
import { Painting } from '~/types/dto/Painting'
import LayoutMenu from '~/components/layout/LayoutMenu.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'PaintingsBlock',
  emits: ['link-clicked'],
  setup(__props, { emit }) {



const firstCol = ref<Array<Painting>>([])
const secondCol = ref<Array<Painting>>([])
const thirdCol = ref<Array<Painting>>([])
const mobileCol = computed(() => {
  const result: Array<Painting> = []
  for (let index = 0; index < firstCol.value?.length; index++) {
    result.push(firstCol.value[index], secondCol.value[index], thirdCol.value[index])
  }

  return result
})

const carousel = ref<HTMLElement | null>(null)
const carouselBg = ref<HTMLElement | null>(null)
const centerColumn = ref()
const mobileColumn = ref()

// const fixed = ref(false)

const loadSize = 36

let nextPageUrl =
  process.env.API_ENDPOINT + `/api/artworks?page_size=${loadSize}&sort_field=random`
let delay = false
let requestSent = false

const getPaintings = () => {
  if (requestSent) {
    return
  }

  requestSent = true

  axios.get(nextPageUrl, {
    cache: false
  }).then((response) => {
    if (response.status === 200) {
      const data = response.data
      const pageData = data.next_page_url
        .slice(data.next_page_url.indexOf('?page='))
        .replace('?', '')
      nextPageUrl = process.env.API_ENDPOINT + `/api/artworks?page_size=${loadSize}&${pageData}`

      const paintings = data.data as Array<Painting>

      const init = loadSize / 3

      firstCol.value = [...firstCol.value, ...paintings.slice(0, init)]
      secondCol.value = [
        ...secondCol.value,
        ...paintings.slice(init, init * 2)
      ]
      thirdCol.value = [
        ...thirdCol.value,
        ...paintings.slice(init * 2, init * 3)
      ]
    }

    requestSent = false
  })
}

getPaintings()

const handleScrollResponse = () => {
  if (delay) {
    return
  }

  delay = true

  setTimeout(() => {
    delay = false
  }, 500)

  const carouselEl = carousel.value as HTMLElement
  const scrolledPercent =
    (carouselEl.scrollTop /
      (carouselEl.scrollHeight - carouselEl.clientHeight)) *
    100

  const scrolledPercentBreakpoint = window.innerWidth < 767
    ? mobileCol.value?.length / (mobileCol.value?.length + loadSize) * 100 + 5
    : (firstCol.value?.length / (firstCol.value?.length + loadSize / 3) * 100) - 25

  if (scrolledPercent > scrolledPercentBreakpoint) {
    getPaintings()
  }
}

const handleScrollBg = () => {
  const scrollTop = (carousel.value as HTMLElement).scrollTop;

  (carouselBg.value as HTMLElement).style.transform = `translateY(${scrollTop / 4
    }px)`
}

onMounted(() => {
  if (!carousel.value || !carouselBg.value) {
    return
  }

  carouselBg.value.style.transform = `translateY(-${0}px)`
  carousel.value.scrollTop = 0
  carousel.value.addEventListener('scroll', handleScrollBg)
  carousel.value.addEventListener('scroll', handleScrollResponse)
})

onUnmounted(() => {
  carousel.value?.removeEventListener('scroll', handleScrollBg)
  carousel.value?.removeEventListener('scroll', handleScrollResponse)
})

return { __sfc: true,emit, firstCol, secondCol, thirdCol, mobileCol, carousel, carouselBg, centerColumn, mobileColumn, loadSize, nextPageUrl, delay, requestSent, getPaintings, handleScrollResponse, handleScrollBg, PaintingsColumn, LayoutMenu }
}

})